import axios from 'utils/axiosInstance'

const BASE_URL_ENDPOINT = '/factors/factors'
const BASE_URL_ENDPOINT_TIPO_AUTOEVALUACION = '/factors/tipo_autoevaluacion'

const getFactores = async (busqueda = '') => {
  const response = await axios.get(`${BASE_URL_ENDPOINT}/?search=${busqueda}`)
  return response.data
}

const getTipoAutoevaluaciones = async (busqueda = '') => {
  const response = await axios.get(`${BASE_URL_ENDPOINT_TIPO_AUTOEVALUACION}/?search=${busqueda}`)
  return response.data
}

const crearFactor = async (values) => {
  const { data, onSuccess: onSuccessMessage } = await axios.post(
    `${BASE_URL_ENDPOINT}/`,
    values,
  )
  return { data, onSuccessMessage }
}

const eliminarFactor = async ({ id, nombre }) => {
  const { onSuccess: onSuccessMessage } = await axios.delete(
    `${BASE_URL_ENDPOINT}/${id}`,
  )
  return { data: nombre, onSuccessMessage }
}

const actualizarFactor = async ({ id, values }) => {
  const { data, onSuccess: onSuccessMessage } = await axios.put(
    `${BASE_URL_ENDPOINT}/${id}/`,
    values,
  )
  return { data, onSuccessMessage }
}

export {
  getFactores,
  getTipoAutoevaluaciones,
  crearFactor,
  eliminarFactor,
  actualizarFactor,
}